"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProduction = exports.isStaging = void 0;
// NOTE: "process.env.NODE_ENV" is set to "production" on both staging and production
const prodEnv = process.env.NODE_ENV === 'production' && typeof window !== 'undefined';
exports.isStaging = prodEnv && window.location.hostname.includes('staging');
exports.isProduction = prodEnv && !window.location.hostname.includes('staging');
//# sourceMappingURL=environment.js.map